import { render, staticRenderFns } from "./ViewerEmptyDesign.vue?vue&type=template&id=edec2b6e"
import script from "./ViewerEmptyDesign.vue?vue&type=script&lang=js"
export * from "./ViewerEmptyDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports